<template>
    <div>
        <div class="newNav" >
            <div style="height: 56px;">
                <img style="width: 100%;height: inherit;position: absolute;" src="../../../../../../static/img/yushelan.png" alt="">
            </div>
            <el-menu default-active="1-4-1" class="el-menu-vertical-demo"
                     :collapse="true">
                <el-submenu index="1"  :disabled="true">
                    <template slot="title">
                        <div class="content-title">
                            无人机:{{wuName}}
                        </div>
                    </template>
                </el-submenu>
                <el-submenu index="2"  :disabled="true">
                    <template slot="title">
                        <div class="content-title">
                            传感器:{{chuangName}}
                        </div>
                    </template>
                </el-submenu>
                <el-submenu index="3"  :disabled="true">
                    <template slot="title">
                        <div class="content-title">
                            起飞地点:{{qiName}}
                        </div>
                    </template>

                </el-submenu>
                <el-submenu index="4"  :disabled="true" >
                    <template slot="title">
                        <div class="content-title">
                            地面控制点:{{dirName}}
                        </div>
                    </template>
                </el-submenu>

                <div class="addElement" style="cursor: not-allowed; color: #b7b7b77d;"  >
                    飞行结果查询与导出
                </div>
                <div class="addElement" @click="submitForm(2)" >
                    三维建模
                </div>
            </el-menu>

        </div>
    </div>

</template>

<script>
    export default {
        name: "index",
        data() {
            return {
                wuName: '',
                chuangName: '',
                qiName: '',
                dirName: '',
            }
        },
        methods: {
            submitForm(index) {
                if (index === 1) {
                    this.$route.push({
                        path:'/flight',
                        query:{
                            wuName : this.wuName,
                            chuangName:this.chuangName,
                            qiName:this.qiName,
                            dirName:this.dirName,
                        }
                    })
                } else {
                    this.goMain('/modeling')

                }
            },
            getData() {
                this.wuName = this.$route.query.wuName
                this.chuangName = this.$route.query.chuangName
                this.dirName = this.$route.query.dirName
                this.qiName = this.$route.query.qiName
            }
        },
        created() {
            this.getData()
        }

    }
</script>

<style lang="less" scoped>
    .el-menu--popup {
        margin-right: 0 !important;
        padding: 0 !important;
    }

    /deep/ .el-menu-item-group__title {
        padding: 0 !important;
    }

    /deep/ .el-menu-item:hover {
        background: #66a3ba !important;
    }

    /deep/ .el-menu--popup-right-start {
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    /deep/ .el-menu-item {
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: white;
        background: #1e354c;
    }

    .newNav {
        width: 190.36px;
        position: absolute;
        z-index: 999;
        left: 20px;
        top: 300px;
        //nav 盒子大小
        .el-menu--collapse {
            width: 100%;
        }
        //
        .el-submenu:first-child {
            border: 2px solid #66a3ba;
            border-image: -webkit-linear-gradient(#66a3ba, #83ccde) 30 30;
            border-image: -moz-linear-gradient(#66a3ba, #83ccde) 30 30;
        }
        .el-submenu {
            border-bottom: 2px solid #66a3ba;
            border-left: 2px solid #66a3ba;
            border-right: 2px solid #66a3ba;

        }

        .el-submenu__title {
            padding: 0 !important;

        }
        /deep/ .el-submenu__title:hover {
            background: #1e354c;
        }
        .el-menu--collapse .el-submenu {
            color: white !important;
            background: #1e354c;
        }

        /deep/ .el-menu-item-group__title {
            padding: 0 !important;
        }

        .content-title {
            color: white;
            text-align: center;
            font-size: 14px;
            font-weight: 600;
        }
        .addElement {
            height: 56px;
            border-bottom: 2px solid #66a3ba;
            border-left: 2px solid #66a3ba;
            border-right: 2px solid #66a3ba;
            text-align: center;
            line-height: 56px;
            background: #1e354c;
            color: white;
            font-weight: 700;
            font-size: 14px;
            cursor: pointer
        }

        //子级导航背景色

    }

</style>



// WEBPACK FOOTER //
// src/views/main/dataCenter/flightSearch/newNav/index.vue